import { TRootState } from "../@types/redux";

export const selectIsUpdateRecipe = (state: TRootState) =>
  state.recipes.isUpdaterecipe;

export const selectRecipeForUpdate = (state: TRootState) =>
  state.recipes.recipesForUpdate;

export const selectRecipeRefreshTable = (state: TRootState) =>
  state.recipes.refreshTablerecipes;

export const selectModalRecipes = (state: TRootState) =>
  state.recipes.recipesModalIsOpen;
